module.exports = __webpack_public_path__ + "images/emoji/deciduous_tree.e6ac54b77cc507f70da8.png";